import { createAction } from '@reduxjs/toolkit'
import * as types from './types'

export const getCycles = createAction(types.GET_CYCLES)
export const getCyclesSuccessful = createAction(types.GET_CYCLES_SUCCESSFUL)
export const getCyclesFailure = createAction(types.GET_CYCLES_FAILURE)
